import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { createSVG } from '../../utils/createSVG/createSVG/index.js';

const IconTextLite = createSVG({
    // eslint-disable-next-line max-len
    children: jsxs(Fragment, { children: [jsx("path", { d: "M11.5913 6V15.7373H16.1685V18H9.22607V6H11.5913Z", fill: "white" }), jsx("path", { d: "M19.8784 18H17.5122V6H19.8784V18Z", fill: "white" }), jsx("path", { d: "M30.0366 6V8.2627H26.7964V18H24.4302V8.2627H21.2085V6H30.0366Z", fill: "white" }), jsx("path", { d: "M38.6938 8.2627H33.7222V10.8174H38.2651V13.0459H33.7222V15.7373H38.7798V18H31.3569V6H38.6938V8.2627Z", fill: "white" })] }),
    width: 48,
});

export { IconTextLite };
